import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '2.725 .0999'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M9.67752 17.2C8.43752 15.6 8.29751 3.90997 9.94751 0.219971H4.08751C5.72751 3.90997 5.59751 15.6 4.35751 17.2C2.98751 18.96 -0.442487 19.1999 0.0475131 21.2899C0.507513 23.2399 5.59751 23.42 6.97751 23.42C8.35751 23.42 13.5375 23.2399 13.9975 21.2899C14.4775 19.1999 11.0475 18.96 9.67752 17.2Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="7.01581"
            y1="2.29437"
            x2="7.01581"
            y2="23.2399"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
